module.exports = __webpack_public_path__ + "img/home-banner-contact2-gr.8ed09aa3.png";